import requests from "./httpService";

const SeoPageServices = {
  getAllSeoPage: async (body) => {
    return requests.get(`/seopage?offset=${body}`);
  },

  addSeoPage: async (body) => {
    return requests.post(`/seopage/add`, body);
  },
  getSeoPageById: async (id) => {
    return requests.get(`/seopage/${id}`);
  },

  updateSeoPage: async (id, body) => {
    return requests.put(`/seopage/update/${id}`, body);
  },

  deleteSeoPage: async (id) => {
    return requests.delete(`/seopage/delete/${id}`);
  },
};

export default SeoPageServices;
